<template>
  <v-card flat rounded="lg">
    <v-card-text>
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12">
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"
            >
              <v-list-item-content>
                <v-list-item-subtitle>Representante</v-list-item-subtitle>
                <v-list-item-title>
                  <span
                    class="font-weight-bold"
                    v-if="id_carga > 0 || !usuarioLogado.colaborador_interno"
                  >
                    {{
                      id_carga == 0
                        ? usuarioLogado.descrepresentante
                        : cargaSelec.desc_vendedor != ""
                        ? cargaSelec.desc_vendedor
                        : "Não vinculado"
                    }}</span
                  >
                  <selecionar-vendedor-relat
                    v-else
                    autoselectfirst
                    autocomplete
                    :disabled="!usuarioLogado.colaborador_interno"
                    label=""
                    dense                    
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col xl="auto" lg="auto" md="auto" cols="12" v-if="id_carga > 0">
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"              
            >
              <v-list-item-content>
                <v-list-item-subtitle>ID</v-list-item-subtitle>
                <v-list-item-title class="font-weight-bold"
                  ><span>{{ id_carga }} </span>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-chip
                  :style="JSON.parse(cargaSelec.status_css)"
                  x-small
                  class="caption ml-5"
                  >{{ cargaSelec.status }}</v-chip
                >
              </v-list-item-action>
            </v-list-item>
          </v-col>

          <v-col xl="4" lg="4" md="4" cols="12">
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"                            
            >
              <v-list-item-content>
                <v-list-item-subtitle>Descrição da carga</v-list-item-subtitle>
                <v-list-item-title>
                  <span class="font-weight-bold" v-if="id_carga > 0">{{
                    cargaSelec.descricao
                  }}</span>
                  <v-text-field
                    v-model="cargaSelec.descricao"
                    :rules="[
                      (v) =>
                        v.trim().length > 3 || 'Informe a descrição da carga',
                    ]"
                    autofocus
                    class="pt-0"
                    v-else
                  ></v-text-field>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="cargaSelec.alterar_descricao">
                <v-btn
                  title="Alterar descrição"
                  icon
                  @click="
                    $router.push({ path: `${$route.path}/alterar-descricao` })
                  "
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </v-col>

          <v-col xl="2" lg="3" md="3" cols="12">
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"
            >
              <v-list-item-content>
                <v-list-item-subtitle>Carregamento a partir de</v-list-item-subtitle>
                <v-list-item-title>
                  <span class="font-weight-bold" v-if="id_carga > 0">{{
                    formatarProgCarreg(cargaSelec.data_hora_prog_carreg)
                  }}</span>
                  <v-select
                    v-else
                    :items="configuracoes.dados.datas_carregamento"
                    item-text="descricao"
                    item-value="data_carreg"
                    class="pt-0"
                    no-data-text="Nenhuma data localizada"
                    v-model="cargaSelec.data_hora_prog_carreg"
                  >
                  </v-select>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col xl="2" lg="2" md="2" cols="12" v-if="id_carga == 0">
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"
            >
              <v-list-item-content>
                <v-list-item-subtitle>Informar placa</v-list-item-subtitle>
                <v-list-item-title>
                  <v-select
                    :items="itens_inf_placa"
                    item-text="text"
                    label=""
                    v-model="infPlacaModel"
                    class="pt-0"
                  ></v-select>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <v-col
            xl="2"
            lg="2"
            md="2"
            cols="12"
            v-if="cargaSelec.informar_placa || id_carga > 0"
          >
            <v-list-item
              :class="{
                'grey lighten-4': id_carga > 0,
                'lista-inf-dados': id_carga == 0,
              }"
              class="rounded-lg"
            >
              <v-list-item-content>
                <v-list-item-subtitle>Placa</v-list-item-subtitle>
                <v-list-item-title>
                  <span class="font-weight-bold" v-if="id_carga > 0">{{
                    cargaSelec.placa != "" ? cargaSelec.placa : "-----"
                  }}</span>
                  <v-autocomplete
                    v-else
                    label=""
                    :items="listaPlacas.dados"
                    auto-select-first
                    :rules="[(v) => !!v || 'Informe a placa']"
                    v-model="placaModel"
                    no-data-text=""
                    class="pt-0"
                  >
                  </v-autocomplete>
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                v-if="
                  cargaSelec.alterar_placa /*&&
                  cargaSelec.dist_caixas.findIndex((cx) => cx.caixa > 0) < 0*/
                "
              >
                <v-btn
                  title="Alterar placa"
                  icon
                  @click="
                    $router.push({ path: `${$route.path}/alterar-placa` })
                  "
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
              </v-list-item-action>
            </v-list-item>
          </v-col>

          <v-col
            cols="12"
            align-self="center"
            v-if="cargaSelec.informar_placa && id_carga == 0"
          >
            <v-btn
              rounded
              color="secondary"
              depressed
              :class="{ 'font-weight-bold': !isMobile() }"
              block
              @click="pesquisarVeiculo()"
              :loading="veiculo.carregando"
              class="mt-3"
              >Buscar veículo <v-icon right>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>

      <v-row v-if="veiculo.msgErro != ''">
        <v-col cols="12">
          <v-alert type="error" class="mt-3" text>{{
            veiculo.msgErro
          }}</v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import SelecionarVendedorRelat from "../relatorios/SelecionarVendedorRelat.vue";

export default {
  components: {
    SelecionarVendedorRelat,
  },
  watch: {
    carregandoVendedores: function (carreg) {
      if (!carreg && this.usuarioLogado.colaborador_interno) {
        this.vendedores.unshift({
          codigo: 0,
          nome: "",
          vendedor_coasul_ext: false,
        });
      }
    },
    vendedorSelecionado: async function (value) {
      this.cargaSelec.cod_vendedor = value;      
      this.cargaSelec.dist_caixas = [];
      // if (this.veiculo.dados) await this.buscarVeiculo();
    },
    [`cargaSelec.informar_placa`]: async function (inf) {
      if (this.id_carga == 0) {
        this.cargaSelec.inf_pedido = !inf;
      }
      this.cargaSelec.dist_caixas = [];
      if (inf) {
        this.veiculo.dados = null;
      } else {
        this.cargaSelec.placa = "";
        await this.buscarVeiculo();
      }
    },
  },
  computed: {
    ...mapState("base", ["vendedores", "carregandoVendedores"]),
    ...mapState("relatorios", ["vendedorSelecionado"]),
    ...mapState("usuario", ["usuarioLogado"]),
    ...mapState("formacaoCarga", [
      "cargaSelec",
      "veiculo",
      "id_carga",
      "cargas",
      "listaPlacas",
      "configuracoes",
    ]),
    placaModel: {
      get: function () {
        return this.placa;
      },
      set: function (value) {
        if (value == null) value = "";
        return (this.cargaSelec.placa = value.toUpperCase());
      },
    },
    infPlacaModel: {
      get: function () {
        return this.cargaSelec.informar_placa;
      },
      set: function (value) {
        this.cargaSelec.informar_placa = value;
      },
    },
  },
  data: () => ({
    itens_inf_placa: [
      { text: "Sim", value: true },
      { text: "Não", value: false },
    ],
  }),
  methods: {
    ...mapMutations("relatorios", ["setVendedor"]),
    ...mapMutations("formacaoCarga", ["setPlaca", "setDescricao"]),
    ...mapActions("formacaoCarga", ["buscarVeiculo"]),
    isMobile() {
      return this.$mq == "sm";
    },
    async pesquisarVeiculo() {
      if (this.$refs.form.validate()) {
        await this.buscarVeiculo();
      }
    },
    formatarProgCarreg(value) {
      moment.locale("pt-Br");
      return moment(value).calendar();
    },   
  },
  mounted() {},
};
</script>

<style>
.lista-inf-dados {
  padding: 3px !important;
}
</style>